import { render, staticRenderFns } from "./Clear.vue?vue&type=template&id=33ecfa58&"
import script from "./Clear.vue?vue&type=script&lang=js&"
export * from "./Clear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports